<ng-container *ngTemplateOutlet="currentTemplate; context: context"></ng-container>

<ng-template #template_default let-title="title">
    <div style="page-break-inside: avoid;">
        <h5>{{title}}</h5>
        <div style="float:left;padding-right:15px;" *ngIf="surf.subseaTrees && surf.subseaTrees.length > 0">
            <table class="optionalComponentSectionTable" style="min-width:20%;max-width:100%">
                <tr>
                    <td style="font-weight: bold;" colspan="2">Subsea Trees</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">Count</td>
                </tr>
                <tr *ngFor="let t of surf.subseaTrees">
                    <td style="padding-right:5px;padding-left:5px;">{{t.type}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{t.count}}</td>
                </tr>
            </table>
        </div>

        <div style="float:left;padding-right:15px;min-width:20%;" *ngIf="surf.umbilicals && surf.umbilicals.length > 0">
            <table class="optionalComponentSectionTable">
                <tr>
                    <td style="font-weight: bold;" colspan="2">Umbilicals</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td style="text-align:right;padding-right:5px;">Length (km)</td>
                </tr>
                <tr *ngFor="let u of surf.umbilicals">
                    <td style="padding-right:5px;padding-left:5px;">{{u.type}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{u.length}}</td>
                </tr>
            </table>
        </div>

        <div style="float:left;padding-right:15px;min-width:20%;max-width:100%" *ngIf="surf.risers && surf.risers.length > 0">
            <table class="optionalComponentSectionTable" style="min-width:20%;max-width:100%">
                <tr>
                    <td style="font-weight: bold;" colspan="2">Risers</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td style="text-align:right;padding-right:5px;">Length (m)</td>
                </tr>
                <tr *ngFor="let r of surf.risers">
                    <td style="padding-right:5px;padding-left:5px;">{{r.type}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{r.length}}</td>
                </tr>
            </table>
        </div>

        <div style="float:left;min-width:33%;" *ngIf="surf.flowlines && surf.flowlines.length > 0">
            <table class="optionalComponentSectionTable">
                <tr>
                    <td style="font-weight: bold;" colspan="4">Flowlines</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td>Fluid</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">Length (km)</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">Diameter (inch)</td>
                </tr>
                <tr *ngFor="let f of surf.flowlines">
                    <td style="padding-right:5px;padding-left:5px;">{{f.type}}</td>
                    <td style="padding-right:5px;padding-left:5px;">{{f.fluid}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{f.length | number:1}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{f.diameter}}</td>
                </tr>
            </table>
        </div>

        <div style="clear:both;"></div>
    </div>
</ng-template>

<ng-template #template_mobile let-title="title">
    <div style="page-break-inside: avoid;">
        <h5>{{title}}</h5>
        <div style="float:left;padding-right:15px;" *ngIf="surf.subseaTree && surf.subseaTrees.length > 0">
            <table class="optionalComponentSectionTable" style="min-width:20%;max-width:100%">
                <tr>
                    <td style="font-weight: bold;" colspan="2">Subsea Trees</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">Count</td>
                </tr>
                <tr *ngFor="let t of surf.subseaTrees">
                    <td style="padding-right:5px;padding-left:5px;">{{t.type}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{t.count}}</td>
                </tr>
            </table>
        </div>

        <div style="float:left;padding-right:15px;min-width:20%;" *ngIf="surf.umbilicals && surf.umbilicals.length > 0">
            <table class="optionalComponentSectionTable">
                <tr>
                    <td style="font-weight: bold;" colspan="2">Umbilicals</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td style="text-align:right;padding-right:5px;">Length (km)</td>
                </tr>
                <tr *ngFor="let u of surf.umbilicals">
                    <td style="padding-right:5px;padding-left:5px;">{{u.type}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{u.length}}</td>
                </tr>
            </table>
        </div>

        <div style="float:left;padding-right:15px;min-width:20%;max-width:100%" *ngIf="surf.risers.length > 0">
            <table class="optionalComponentSectionTable" style="min-width:20%;max-width:100%">
                <tr>
                    <td style="font-weight: bold;" colspan="2">Risers</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td style="text-align:right;padding-right:5px;">Length (m)</td>
                </tr>
                <tr *ngFor="let r of surf.risers">
                    <td style="padding-right:5px;padding-left:5px;">{{r.type}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{r.length}}</td>
                </tr>
            </table>
        </div>

        <div style="float:left;min-width:33%;" *ngIf="surf.flowlines && surf.flowlines.length > 0">
            <table class="optionalComponentSectionTable">
                <tr>
                    <td style="font-weight: bold;" colspan="4">Flowlines</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td>Fluid</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">Length (km)</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">Diameter (inch)</td>
                </tr>
                <tr *ngFor="let f of surf.flowlines">
                    <td style="padding-right:5px;padding-left:5px;">{{f.type}}</td>
                    <td style="padding-right:5px;padding-left:5px;">{{f.fluid}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{f.length | number:1}}</td>
                    <td style="text-align:right;padding-right:5px;padding-left:5px;">{{f.diameter}}</td>
                </tr>
            </table>
        </div>

        <div style="clear:both;"></div>
    </div>
</ng-template>